export default "__VITE_ASSET__9fc0a264__"